// extracted by mini-css-extract-plugin
export default {"menu":"menu_menu__AMsan","welcome":"menu_welcome__8o67C","subMenu":"menu_subMenu__CImzl","item":"menu_item__6E57X"};